/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response when parameters does not matter
 * @export
 * @interface SimpleAidDto
 */
export interface SimpleAidDto {
    /**
     * Autonomic Identifier
     * @type {string}
     * @memberof SimpleAidDto
     */
    aid?: string;
}

/**
 * Check if a given object implements the SimpleAidDto interface.
 */
export function instanceOfSimpleAidDto(value: object): boolean {
    return true;
}

export function SimpleAidDtoFromJSON(json: any): SimpleAidDto {
    return SimpleAidDtoFromJSONTyped(json, false);
}

export function SimpleAidDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleAidDto {
    if (json == null) {
        return json;
    }
    return {
        
        'aid': json['aid'] == null ? undefined : json['aid'],
    };
}

export function SimpleAidDtoToJSON(value?: SimpleAidDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'aid': value['aid'],
    };
}

